import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { AuthService } from "./auth.service";
import { UtilitesService } from "./utilites.service";

/**
 * PROSP-594: configuração da janela de inatividade da sessão.
 *
 * Espelha o endpoint enxuto do backend (Modules\Base SessaoController):
 *  - GET  sessao/idle-timeout -> { data: { minutes } }  (livre p/ autenticados)
 *  - PUT  sessao/idle-timeout { minutes }                (restrito a admin)
 */
@Injectable({ providedIn: "root" })
export class SessaoService {
    constructor(
        private _http: HttpClient,
        private authService: AuthService,
        private utilitesService: UtilitesService
    ) {}

    /** Lê o timeout efetivo (minutos) da sessão. */
    getIdleTimeout(): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "sessao/idle-timeout", {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /** Altera o timeout (minutos). Requer permissão de admin no backend. */
    updateIdleTimeout(minutes: number): Observable<any> {
        return this._http.put(
            this.utilitesService.urlPrefix + "sessao/idle-timeout",
            JSON.stringify({ minutes }),
            { headers: this.authService.getAuthHeaders() }
        );
    }
}
